import { render, staticRenderFns } from "./OrderReports.vue?vue&type=template&id=e23ea374&scoped=true&"
import script from "./OrderReports.vue?vue&type=script&lang=js&"
export * from "./OrderReports.vue?vue&type=script&lang=js&"
import style0 from "./OrderReports.vue?vue&type=style&index=0&id=e23ea374&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23ea374",
  null
  
)

export default component.exports